export default __webpack_public_path__ + "static/FWAProduct-62c585531f2bdd5c9812bf3374bad342.png";